import { SchedulerViewType } from 'src/app/core/enums';



export class SchedulerFilterModel {
    constructor(
        public SchedulerIDs: number[],
        public Start?: Date,
        public End?: Date,
        public ViewType?: SchedulerViewType,
        public SchedulerType?: string,
        public FirstDayOfWeek?: number,
        public Practise?:string,
        public Department?: string
        ){  }

}
